// src/routes/PrivateRoute.js
import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import AuthContext from '../context/AuthContext';

const PrivateRoute = ({ element }) => {
    const token = localStorage.getItem("ACCESS_TOKEN");
    const { user } = useContext(AuthContext); 
    console.log(user, "Access token")
    if (user || token) {
        return element;
    }

    return <Navigate to="/login" />;
};

export default PrivateRoute;
